module.exports = __webpack_public_path__ + "media/img/illustrations/coworking-806e409e2bf05f59babec8d8adc6d7ef.svg";